import Vue from 'vue'
import Vuex from 'vuex'
import admin from './modules/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: {
      name: 'Diklat Bandung Kiwari'
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    admin,
  }
})
